/*
 * Botão flutuante de WhatsApp (app CK WhatsApp / CartHike) na página de produto, no celular.
 *
 * Ao descer a página, a barra fixa de compra (sticky add to cart) aparece embaixo e
 * ficava por cima do botão do app (#carthike-chat-button-container). Aqui o botão sobe
 * o suficiente para ficar acima da barra enquanto ela estiver visível, e volta quando
 * ela some. No desktop nada muda (a barra fica no centro e não encosta no botão).
 */
(() => {
  if (window.BracciWhatsappFloat) return;
  window.BracciWhatsappFloat = true;

  const SELECTOR = '#carthike-chat-button-container';
  const GAP = 12;
  const MOBILE = window.matchMedia('(max-width: 749px)');

  // Quanto o botão precisa subir para ficar acima da barra (0 se a barra não estiver visível).
  // Usa a posição final da barra (bottom + altura), não a da animação de entrada.
  function lift(button) {
    if (!MOBILE.matches) return 0;
    const bar = document.querySelector('.sticky-add-to-cart__bar[data-stuck="true"]');
    if (!bar || !bar.offsetHeight) return 0;
    const barTop = (parseFloat(getComputedStyle(bar).bottom) || 0) + bar.offsetHeight;
    const buttonBottom = parseFloat(getComputedStyle(button).bottom) || 0;
    return Math.max(0, barTop + GAP - buttonBottom);
  }

  function apply(button) {
    const offset = lift(button);
    button.style.setProperty('transition', 'transform 0.3s ease', 'important');
    if (offset) button.style.setProperty('transform', `translateY(-${offset}px)`, 'important');
    else button.style.removeProperty('transform');
  }

  function init(button) {
    if (button.dataset.bracciFloat) return;
    button.dataset.bracciFloat = 'true';

    const update = () => apply(button);
    const watch = new MutationObserver(update);
    // data-stuck na barra (aparece/some ao rolar) e data-variant-available no componente.
    document.querySelectorAll('sticky-add-to-cart').forEach((sticky) => {
      watch.observe(sticky, { attributes: true, subtree: true, attributeFilter: ['data-stuck', 'data-variant-available'] });
    });
    MOBILE.addEventListener?.('change', update);
    window.addEventListener('resize', update);
    update();
  }

  const existing = document.querySelector(SELECTOR);
  if (existing) {
    init(existing);
    return;
  }

  // O app injeta o botão depois do carregamento.
  const observer = new MutationObserver(() => {
    const button = document.querySelector(SELECTOR);
    if (!button) return;
    observer.disconnect();
    init(button);
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 30000);
})();
